import { usePolygonEditor } from '@/lib/geometry/usePolygonEditor';
import { DeviceSnapshot } from './DeviceSnapshot';
import { cn } from '@/lib/utils';
import { ComponentProps, useEffect } from 'react';
import { SecondaryDeviceFullDto } from '@/lib/api/types.gen';

export const DeviceSnapshotWithReadonlyGrid = (
  props: ComponentProps<'div'> &
    Pick<SecondaryDeviceFullDto, 'id' | 'activationWkt'> & {
      onLoad?: () => void;
    }
) => {
  const { id, activationWkt, onLoad, ...rest } = props;
  const poly = usePolygonEditor({ readonly: true });

  useEffect(() => {
    const features = poly.util.fromWkt(activationWkt ?? '');

    poly.form.reset({ polygons: features });
  }, [poly.util.fromWkt, poly.form, activationWkt]);

  return (
    <div
      {...rest}
      className={cn('pointer-events-none relative', rest.className)}
      ref={poly.targetRef}
    >
      <DeviceSnapshot
        deviceId={id}
        className={cn('pointer-events-none w-full select-none', props.className)}
        onLoad={() => {
          poly.reload();
          onLoad?.();
        }}
      />
      {props.children}
      <canvas ref={poly.canvasRef} {...poly.canvasProps} />
    </div>
  );
};
